module.exports = __webpack_public_path__ + "static/media/group_icon.87323d82.png";